const PickupIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3403_15945)">
        <path
          d="M2.41172 15.9866L2.40304 15.9863H2.39435C2.04285 15.9863 1.77139 15.6762 1.81775 15.3279C1.81776 15.3279 1.81776 15.3279 1.81777 15.3278L2.95413 6.82188C2.95414 6.82185 2.95414 6.82181 2.95415 6.82177C2.99556 6.51308 3.36753 6.37707 3.59827 6.58608C4.73316 7.61486 5.81872 8.1457 6.82463 8.33496C7.83152 8.52439 8.72192 8.36464 9.45404 8.07108C10.1818 7.77926 10.754 7.35533 11.1418 7.00911C11.2511 6.91152 11.3467 6.81933 11.4278 6.73689L21.1909 14.0915L21.191 14.0915C22.02 14.7158 22.5265 15.6673 22.5928 16.6881L2.41172 15.9866Z"
          fill="#FD7E14"
          stroke="#1C1D1F"
        />
        <path
          d="M11.3614 6.06549L9.28538 4.69629C9.28538 4.69629 8.05238 6.33009 8.95598 7.72209C8.95598 7.72209 9.99218 7.61169 11.3614 6.06549Z"
          fill="#1C1D1F"
        />
        <path
          d="M12.0712 10.7701C12.523 11.1625 13.2076 11.1139 13.6 10.6621L15.121 8.9095L13.414 7.6123L11.9626 9.2413C11.5702 9.6931 11.6194 10.3777 12.0712 10.7701Z"
          fill="#1C1D1F"
        />
        <path
          d="M15.262 12.3368C15.7138 12.7292 16.3984 12.6806 16.7908 12.2288L17.8786 10.9754L16.1434 9.66797L15.154 10.808C14.7616 11.2598 14.8102 11.9444 15.262 12.3368Z"
          fill="#1C1D1F"
        />
        <path
          d="M2.08043 19.3039H21.0458C22.2218 19.3039 23.1182 18.3277 23.09 17.2057L1.34423 15.1729L0.91103 17.9677C0.81623 18.6751 1.36643 19.3039 2.08043 19.3039Z"
          fill="#1C1D1F"
        />
        <path
          d="M1.85555 11.3396C1.85555 11.3396 5.21435 12.5786 5.64575 15.5756H1.5L1.85555 11.3396Z"
          fill="#1C1D1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_3403_15945">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PickupIcon;
